import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

const Reveal = ({ children, delay = 0, className = "" }) => (
  <div className="reveal-mask">
    <motion.div
      className={className}
      initial={{ y: "110%" }}
      whileInView={{ y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  </div>
);

export const About = () => {
  return (
    <section
      id="about"
      className="relative border-t hairline py-24 md:py-40"
      data-testid="about-section"
    >
      <div className="grid grid-cols-12 gap-6 md:gap-10 px-6 md:px-10 lg:px-14">
        {/* Sticky label */}
        <aside className="col-span-12 md:col-span-3 md:sticky md:top-32 h-fit">
          <Reveal>
            <span className="label">01 — The Visionary</span>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 font-sans text-sm text-mute max-w-[240px] leading-relaxed">
              Where aesthetics meet performance.
            </p>
          </Reveal>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.1, ease: EASE, delay: 0.15 }}
            className="mt-10 hidden md:block aspect-[3/4] w-full max-w-[300px] overflow-hidden"
            data-testid="about-portrait"
          >
            <img
              src="https://customer-assets-jai6qajn.emergentagent.net/job_akanksha-creative/artifacts/nos0wsf8_IMG_7242.jpg"
              alt="Akanksha Chandok"
              className="w-full h-full object-cover gray-hover"
            />
            <p className="mt-3 label">Akanksha · Founder, Hypmmedia</p>
          </motion.div>
        </aside>

        <div className="col-span-12 md:col-span-9">
          <h2 className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[1.05] text-ink">
            <Reveal>
              <span>She leads with a rare balance of</span>
            </Reveal>
            <Reveal delay={0.08}>
              <span className="italic text-ink/90">
                creativity, intuition,
              </span>
            </Reveal>
            <Reveal delay={0.16}>
              <span>and business acumen — merging</span>
            </Reveal>
            <Reveal delay={0.24}>
              <span className="italic">
                the language of luxury{" "}
                <span className="text-mute">&nbsp;</span>
              </span>
            </Reveal>
            <Reveal delay={0.32}>
              <span>with the discipline of performance.</span>
            </Reveal>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-16 md:mt-24">
            <div>
              <span className="label">Founder’s Note</span>
              <p className="mt-4 font-sans text-base md:text-lg text-ink/85 leading-relaxed">
                At Hypmmedia, Akanksha heads the Creative, Strategy, and Client
                Success functions — ensuring every campaign delivers measurable
                value while staying visually elevated. Creativity, to her, isn’t
                just a profession; it’s a mindset that shapes how brands
                communicate, connect, and grow.
              </p>
            </div>
            <div>
              <span className="label">Legacy</span>
              <p className="mt-4 font-sans text-base md:text-lg text-ink/85 leading-relaxed">
                Before founding Hypmmedia, Akanksha worked with some of the
                most influential global and luxury beauty houses — an exposure
                that shaped her fluency in brand behaviour, consumer psychology,
                luxury marketing, and high-impact digital activations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
